import {
  urlJoin,
  eatAll,
  get_full_url as getFullUrl,
  get_full_path as getFullPath,
  path_to_url as pathToUrl,
  url_to_path as urlToPath
} from '@putkoff/abstract-utilities';
export const tdd_dir = '/srv/thedailydialectics/app'
export const tdd_url = 'https://thedailydialectics.com';
export const public_dir = urlJoin(tdd_dir, 'public');
export const src_dir = urlJoin(tdd_dir, 'src');
export const contents_dir = urlJoin(src_dir, 'contents');
export const json_pages_dir = urlJoin(src_dir, 'json_pages');
export const pages_dir = urlJoin(src_dir, 'pages');
export const imgs_dir = urlJoin(public_dir, 'imgs');
export const pdfs_dir = urlJoin(public_dir, 'pdfs');
export const tdd_pdf_url = urlJoin(tdd_url, 'pdf');
export const tdd_imgs_url = urlJoin(tdd_url, 'imgs');
export const tdd_pdfs_url = urlJoin(tdd_url, 'pdfs');
// NOTE (2026-07-07): the API subdomain is DEAD (vhost removed 2026-07-07). All of
// its endpoint constants (tdd_api_url, tdd_valid_pdf_links_url, …) were removed
// with it. PDF metadata is static now: same-origin /pdfs/<baseId>/info.json
// (see get_pdf_urls below); the navbar is generated at build time.
export const all_paths = {
  "imgs": {
    "url": tdd_imgs_url,
    "path": imgs_dir
  },
  "pdfs": {
    "url": tdd_pdfs_url,
    "path": pdfs_dir
  },
  "pages": {
    "url": tdd_url,
    "path": pages_dir
  },
  "json_pages": {
    "url": tdd_url,
    "path": json_pages_dir
  },
  "contents": {
    "url": tdd_url,
    "path": contents_dir
  }
}

/**
 * Returns a full URL.
 * If partial_url is already absolute (starts with http), it is returned as is.
 * Otherwise, it is combined with the base URL.
 */
export function get_full_url(partial_url: any) {
  return getFullUrl(partial_url, tdd_url)
}

/**
 * Returns a full file system path.
 * If partial_path is already absolute, it is returned as is.
 * Otherwise, it is joined with the base directory.
 */
export function get_full_path(partial_path: any) {
  return getFullPath(partial_path, tdd_dir)
}

/**
 * Converts a local file system path into its corresponding URL.
 * It checks against the known directories in all_paths and replaces the matching base.
 */
export function path_to_url(filePath: string): string | null {
  return pathToUrl(filePath, all_paths);

}

/**
 * Converts a URL into its corresponding local file system path.
 * It checks against the known URL prefixes in all_paths and replaces the matching base.
 */

export function url_to_path(urlStr: string): string | null {
  return urlToPath(urlStr, all_paths);
}


function get_filename(filename: string): string {
  return filename.replace(/\.[^/.]+$/, ""); // remove extension
}

export function get_pdf_baseId_from_url(url?: string | null, baseId?: string | null): string | null {
  if (!url && !baseId) return null;

  // Use baseId if explicitly provided
  if (baseId && typeof baseId === "string") return baseId;

  if (typeof url === "string" && url.trim()) {
    const parts = url.split("/").filter(Boolean);
    if (parts.length === 0) return null;

    let basename = parts.at(-1) || "";
    if (basename === "info.json") basename = parts.at(-2) || basename;

    return get_filename(basename);
  }

  return null;
}

export function get_pdf_urls(baseId?: string | null, customBaseUrl?: string | null) {
  if (!baseId) throw new Error("baseId is required to build PDF URLs.");

  const pdfBaseUrl = `/pdfs/${baseId}`;
  const pdfInfoUrl = `${pdfBaseUrl}/info.json`;
  const pdfUrl = `${pdfBaseUrl}/${baseId}.pdf`;
  const txtUrl = `${pdfBaseUrl}/${baseId}.txt`;
  const imgUrl = `${pdfBaseUrl}/${baseId}.png`;
  const pdfSiteUrl = urlJoin(customBaseUrl || tdd_pdfs_url, baseId);

  return { pdfBaseUrl, pdfInfoUrl, pdfUrl, txtUrl, imgUrl, pdfSiteUrl, baseId };
}

export function get_pdf_base_url(baseId: string) {
  return get_pdf_urls(baseId).pdfBaseUrl;
}

export function get_pdf_info_url(baseId: string) {
  return get_pdf_urls(baseId).pdfInfoUrl;
}

export function get_pdf_url(baseId: string) {
  return get_pdf_urls(baseId).pdfUrl;
}

export function get_pdf_site_url(baseId: string) {
  return get_pdf_urls(baseId).pdfSiteUrl;
}
export function get_pdf_content_link(i: number, baseId: string, ext: string | null = null) {
  if (ext) ext = `.${eatAll(ext, ['.'])}`;
  ext = ext || '';
  let mime: 'pages' | 'images' = 'pages';
  if (ext.includes('png')) mime = 'images';
  return `${tdd_pdfs_url}/${baseId}/${mime}/page_${i}/${baseId}_page_${i}${ext}`;
}
export const pdfPageTxt = (id: string, n: number) =>
  `${tdd_pdfs_url}/${id}/pages/page_${n}/${id}_page_${n}.txt`;

export const pdfPagePng = (id: string, n: number) =>
  `${tdd_pdfs_url}/${id}/images/page_${n}/${id}_page_${n}.png`;
